// @ts-nocheck


import React from 'react';







import {
  vehicleTypes,
  contractVehicleType,
  vehicleStatuses } from
'./../../../../../../../lib/enum';
import { formatDateTimeToString } from './../../../../../../../lib/helpers';
import { Table } from './../../../../../../../components/ui';









const COLUMNS = [
{
  title: 'Тип ТС',
  width: 200,
  dataIndex: 'vehicle.vehicleModel.type',
  render: (type) => vehicleTypes[type]
},
{
  title: 'Maрка и модель',
  width: 150,
  dataIndex: 'vehicle.vehicleModel',
  render: (record) => `${record.brandName} ${record.name}`
},
{
  title: 'Госномер',
  width: 150,
  dataIndex: 'vehicle.licensePlate'
},
{
  title: 'Год выпуска',
  width: 100,
  dataIndex: 'vehicle.yearIssued'
},
{
  title: 'Тип НТС',
  width: 150,
  dataIndex: 'type',
  render: (type) => contractVehicleType[type]
},
{
  title: 'Дата начала',
  width: 150,
  dataIndex: 'startDateStatus',
  render: (startDateStatus) =>
  formatDateTimeToString(startDateStatus, 'DD.MM.YYYY')
},
{
  title: 'Дата окончания',
  width: 150,
  dataIndex: 'endDateStatus',
  render: (endDateStatus) =>
  formatDateTimeToString(endDateStatus, 'DD.MM.YYYY')
},
{
  title: 'Текущий статус',
  width: 100,
  dataIndex: 'vehicle.status',
  render: (status) => vehicleStatuses[status]
}];


export default (props) => {
  const { data, loading, selectedRowKeys, onSelect, onSelectAll } = props;
  const rowSelection =
  onSelect && onSelectAll ?
  {
    selectedRowKeys,
    onSelect,
    onSelectAll
  } :
  undefined;
  return (
    <div style={{ overflow: 'auto' }}>
      <Table
        style={{ minWidth: '1490px' }}
        rowSelection={rowSelection}
        columns={COLUMNS}
        data={data}
        loading={loading}
        scroll={{ y: 240 }} />

    </div>);

};
